import qs from 'qs';

import type { SuggestedPetition, VictoriousPetition } from '../api';
import type { SuggestedPetitionSourceLocation } from '../types';

type GeneratedUrls = {
	petitionUrl: string;
	petitionSignUrl: string;
	petitionPromotersUrl: string;
};

export const generatePetitionUrl = ({
	petition,
	gridPosition,
	parentPetitionId,
	sourceLocation,
	victory,
}: {
	petition: SuggestedPetition | VictoriousPetition;
	gridPosition: number;
	parentPetitionId?: string;
	sourceLocation: SuggestedPetitionSourceLocation;
	victory?: boolean;
}): GeneratedUrls => {
	const {
		node: { slug },
		algorithm,
		promotionToken,
	} = petition;

	const queryParams = {
		original_footer_petition_id: parentPetitionId,
		pt_algorithm: algorithm,
		source_location: victory ? `${sourceLocation}_victory` : sourceLocation,
		grid_position: gridPosition,
		...(promotionToken && { pt: promotionToken }),
	};
	return {
		petitionUrl: `/p/${slug}?${qs.stringify(queryParams, { encodeValuesOnly: true })}`,
		petitionSignUrl: `/p/${slug}?${qs.stringify({ show_sign: true, ...queryParams }, { encodeValuesOnly: true })}`,
		petitionPromotersUrl: `/p/${slug}/promoters?${qs.stringify(queryParams, { encodeValuesOnly: true })}`,
	};
};
